/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const validationDataSchema = z.object({
	valid: z.boolean(),
	missingFields: z.array(z.string()),
	message: z.string().nullable(),
})

export type ValidationDataSchema = z.infer<typeof validationDataSchema>
